export const lkprimary = "#005C8E";
export const lkred = "#DC272D";
export const lkltblue = "#1C8BCB";
export const lkgreen = "#00943D";
export const lkyellow = "#FBCA2F";
